import { Toolbar, IconButton, Typography, Button } from '@mui/material';
import { AppBarStyled } from 'shared/_components/app-layout/app-bar/styles';
import { ChevronLeft, ChevronRight, Menu } from '@mui/icons-material';
import { Header } from 'shared/Pages/common/Header';
import { useAtom } from 'jotai';
import { drawerExpandedAtom, drawerOpenAtom } from 'shared/_components/app-layout/store';

export default function AppBar() {
	const [drawerOpen, setDrawerOpen] = useAtom(drawerOpenAtom);
	const [drawerExpanded, setDrawerExpanded] = useAtom(drawerExpandedAtom);

	return (
		<AppBarStyled open={drawerOpen} expanded={drawerExpanded} color="inherit">
			<Toolbar sx={(theme) => ({
				px: theme.spacing(4),
				[theme.breakpoints.up('sm')]: {
					px: theme.spacing(4),
				},
			})}>
				<IconButton
					onClick={() => {
						setDrawerExpanded((s) => !s);
					}}
					edge="start"
					color="inherit"
					aria-label="menu"
					sx={{ mr: 2, display: { xs: 'none', sm: 'flex' } }}
				>
					{drawerExpanded ? <ChevronLeft /> : <ChevronRight />}
				</IconButton>
				<Button
					startIcon={<Menu
						// fontSize="1.25rem"
						width={20} height={20}
					/>}
					// size="large"
					onClick={() => {
						setDrawerOpen((s) => !s);
					}}
					// edge="start"
					// color="inherit"
					aria-label="menu"
					sx={(theme) => ({
						p: 2, // theme.spacing(2),
						mr: 2,
						display: { sm: 'none' },
						'.MuiButton-startIcon': {
							mx: 0,
						},
						// '&.MuiButton-root .MuiButton-startIcon > svg': {
						// 	fontSize: theme.spacing(6),
						// // width: '20px', height: '20px',
						// }
					})}
				/>
					{/*<Menu width={20} height={20} />*/}
				{/*</Button>*/}
				{/*<IconButton*/}
				{/*	onClick={() => {*/}
				{/*		setDrawerOpen((s) => !s);*/}
				{/*	}}*/}
				{/*	edge="start"*/}
				{/*	color="inherit"*/}
				{/*	aria-label="menu"*/}
				{/*	sx={{ mr: 2, display: { sm: 'none' } }}*/}
				{/*>*/}
				{/*	<Menu />*/}
				{/*</IconButton>*/}
				<Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
					<Header />
				</Typography>
			</Toolbar>
		</AppBarStyled>
	);
}
